module.exports = __webpack_public_path__ + "static/img/546.0aae491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/546.jpg
// module id = lMdn
// module chunks = 171